// Estilos compartidos para el Localizador de Servicios

export const colors = {
  bg: '#f9fafb',
  surface: '#ffffff',
  surfaceHover: '#f3f4f6',
  border: '#e5e7eb',
  borderFocus: '#84cc16',
  accent: '#84cc16',
  accentHover: '#65a30d',
  accentLight: '#ecfccb',
  textPrimary: '#1f2937',
  textSecondary: '#6b7280',
  textMuted: '#9ca3af',
  error: '#dc2626',
  errorBg: '#fef2f2',
  success: '#16a34a',
  successBg: '#f0fdf4',
  warning: '#d97706',
  warningBg: '#fffbeb',
  info: '#2563eb',
  infoBg: '#eff6ff',
};

export const baseStyles = {
  container: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    backgroundColor: colors.bg,
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
  main: {
    flex: 1,
    padding: "1rem",
    maxWidth: "600px",
    margin: "0 auto",
    width: "100%",
    boxSizing: "border-box",
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: "0.75rem",
    marginBottom: "1.5rem",
    paddingBottom: "1rem",
    borderBottom: `1px solid ${colors.border}`,
  },
  backButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "44px",
    height: "44px",
    minWidth: "44px", // Touch target minimum
    minHeight: "44px",
    backgroundColor: colors.surface,
    border: `1px solid ${colors.border}`,
    borderRadius: "8px",
    cursor: "pointer",
    transition: "background-color 0.2s",
    flexShrink: 0,
  },
  title: {
    fontSize: "1.25rem",
    fontWeight: 600,
    color: colors.textPrimary,
    margin: 0,
    letterSpacing: "-0.025em",
  },
  subtitle: {
    fontSize: "0.875rem",
    color: colors.textSecondary,
    margin: "0.5rem 0 0 0",
  },
  sectionTitle: {
    fontSize: "0.75rem",
    fontWeight: 600,
    color: colors.textMuted,
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    marginBottom: "0.75rem",
    marginTop: "1.5rem",
  },
  card: {
    backgroundColor: colors.surface,
    border: `1px solid ${colors.border}`,
    borderRadius: "12px",
    padding: "1rem",
    marginBottom: "0.75rem",
  },
  divider: {
    height: "1px",
    backgroundColor: colors.border,
    margin: "1rem 0",
  },
};
